import {
  Sanity$AccordionFAQ,
  Sanity$MainHardwareType,
  Sanity$Section,
} from '@otovo/shared/types/sanityTypes';
import ContentRow from './ContentRow';
import { createRowContext } from './lib';

type Props = {
  rows: Sanity$Section[];
  rowContext?: {
    faqItems?: Sanity$AccordionFAQ[];
    mainHardwareType?: Sanity$MainHardwareType;
  };
  storefrontV2Enabled?: boolean;
};

const ContentRowList = ({
  rows,
  storefrontV2Enabled = false,
  rowContext = {},
}: Props) => {
  return (
    <>
      {rows.map((row, index) => (
        <ContentRow
          key={`contentRow-${index}-${row._key}`}
          row={row}
          rowContext={createRowContext(index, rowContext, storefrontV2Enabled)}
        />
      ))}
    </>
  );
};

export default ContentRowList;
